import React, { createContext, useContext, useState } from "react";

const LoaderContext = createContext({
  loading: true,
  setLoading: () => null,
});

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};
